import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1AdminWorkGroupMembershipIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class AdminWorkGroupMembershipEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_work_group_memberships",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.AdminWorkGroupMembership-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminWorkGroupMembershipIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminWorkGroupMembership-001";
        payload.ShifamedMessage.AdminWorkGroupMembership = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_work_group_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminWorkGroupMembership-001",
                "idoc-response": "v1.AdminWorkGroupMembership-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminWorkGroupMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let projectPlan = {};

        projectPlan["USID"] = this.getAttributeValue("USID");
        projectPlan["Name"] = this.getAttributeValue("Name");
        projectPlan["EmployeeUSID"] = this.getAttributeValue("EmployeeUSID");
        projectPlan["Active"] = true;

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminWorkGroupMembership-001";
        payload.ShifamedMessage.AdminWorkGroupMembership = projectPlan;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/project_plans",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlan-001",
                "idoc-response": "v1.ProjectPlan-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminWorkGroupMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default AdminWorkGroupMembershipEnterpriseComponent;